import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAlertTriangleYellow = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 17,
	height: 17,
	viewBox: "0 0 17 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M7.23355 2.69749L1.58688 12.1242C1.47046 12.3258 1.40886 12.5544 1.40821 12.7872C1.40756 13.02 1.46788 13.2489 1.58317 13.4512C1.69846 13.6534 1.8647 13.822 2.06535 13.9401C2.26601 14.0581 2.49408 14.1216 2.72688 14.1242H14.0202C14.253 14.1216 14.4811 14.0581 14.6817 13.9401C14.8824 13.822 15.0486 13.6534 15.1639 13.4512C15.2792 13.2489 15.3395 13.02 15.3389 12.7872C15.3382 12.5544 15.2766 12.3258 15.1602 12.1242L9.51355 2.69749C9.3947 2.50156 9.22736 2.33957 9.02768 2.22715C8.828 2.11473 8.60271 2.05566 8.37355 2.05566C8.14439 2.05566 7.9191 2.11473 7.71942 2.22715C7.51973 2.33957 7.3524 2.50156 7.23355 2.69749Z",
					fill: "#fff6d7",
					fillOpacity: .2,
					stroke: "#EACA5B",
					strokeWidth: 1.5,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.37305 6.12402V8.79069",
					stroke: "#EACA5B",
					strokeWidth: 1.5,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.37305 11.457H8.37971",
					stroke: "#EACA5B",
					strokeWidth: 1.5,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0",
			children: /* @__PURE__ */ _jsx("rect", {
				x: .373047,
				y: .124023,
				width: 16,
				height: 16,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgAlertTriangleYellow);
export { ForwardRef as ReactComponent };
